import type { Types } from '../types';
import type { OutTypes } from './schedules';
import { getVertexId } from '../util';
import { omitEdgesAndInternalProperties, type SerializedEdgesOnlyVertexExport, type SerializedEdgesShape } from './util';
import type { BaseOptions } from '../../common/types';
import type { CourseVertex } from '../interfaces/vertices/courses';


export default (
  courses: Types.Mixed.Course[],
  options: BaseOptions
): OutTypes.course[] => {
  return courses
    .map(x => {
      const edges: SerializedEdgesOnlyVertexExport<CourseVertex> = {
        period:       x.period         ? getVertexId(x.period,         options) : undefined,
        syllabus:     x.syllabus       ? getVertexId(x.syllabus,       options) : undefined,
        events:       x.events      ?.map(x => getVertexId(x, options)),
        lockedTimes:  x.lockedTimes ?.map(x => getVertexId(x, options)),
        exceptions:   x.exceptions  ?.map(x => getVertexId(x, options)),
        teachers:     x.teachers    ?.map(x => ({ ...x, to: getVertexId(x.to, options) })),
        participants: x.participants?.map(x => ({ ...x, to: getVertexId(x.to, options) })),
        groups:       x.groups      ?.map(x => ({ ...x, to: getVertexId(x.to, options), exclude: x.exclude?.map(y => getVertexId(y, options)) })),
        locations:    x.locations   ?.map(x => ({ ...x, locations: [getVertexId(x.locations[0], options)] as [string] })),
      } satisfies SerializedEdgesShape<SerializedEdgesOnlyVertexExport<CourseVertex>>;
      const nonEdges = omitEdgesAndInternalProperties(x, edges);

      return { ...nonEdges, ...edges };
    });
};
